/**
 * Adds an event listener for the 'cart:change' event.
 * Updates the cart item count after a delay.
 */
document.addEventListener("cart:change", function (event) {
  upsellNavigation();
  toggleUpsellVisibility();
  // document.querySelector('[data-name="cart-count-nav"]').textContent = document.querySelector('[data-name="cart-quantity"]').getAttribute('data-label');
  setTimeout(() => {
    document.querySelector('[data-name="cart-count-nav"]').textContent = document.querySelector('[data-name="cart-quantity"]').getAttribute('data-label');
  }, 200);
});

document.addEventListener("cart:refresh", () => {
  upsellNavigation();
  toggleUpsellVisibility();
  setTimeout(() => {
    const counter = document.querySelector('[data-name="cart-quantity"]');
    if (counter) {
      const value = Number(counter.textContent.trim());
      if (!isNaN(value)) {
        const label = value > 1 ? 'items' : 'item';
        counter.textContent += `${label}`;
        if (value > 99) {
          document.querySelector('[data-name="cart-count-nav"]').textContent = "∞";
        } else {
          document.querySelector('[data-name="cart-count-nav"]').textContent = value;
        }
      }
    }
  }, 900);
});

function incrementCartCount() {
  upsellNavigation();
  toggleUpsellVisibility();
  document.querySelector('[data-name="cart-count-nav"]').textContent = Number(document.querySelector('[data-name="cart-count-nav"]').textContent) + 1;
}
